
<script lang="ts" setup>
import useStaticData from '@/composables/useStaticData'

const { getItems } = useStaticData()
const items = await getItems(['policy'])
const { privacy } = items
</script>

<template>
  <UiPolicy
    :title="$t('privacy.title')"
    :subtitle="$t('privacy.subtitle')"
    :policy="privacy"
    :table-of-contents="true"
  />
</template>
